import { BillType } from '../../../graphql/generated/graphql'
import { MerchantDetails } from '../components/linkBill/LinkBill'

const toBillType = (type: string): BillType => {
    switch (type) {
        case 'student_loan':
            return BillType.StudentLoan
        case 'credit_card':
            return BillType.CreditCard
        case 'loan':
        case 'business_loan':
        case 'personal_loan':
            return BillType.Loan
        case 'auto_loan':
            return BillType.AutoLoan
        case 'mortgage':
        case 'home_loan':
        case 'home_equity_loan':
            return BillType.Mortgage
        case 'electric_utility':
        case 'internet_utility':
        case 'telephone_utility':
        case 'television_utility':
        case 'water_utility':
        case 'waste_utility':
        case 'utility':
            return BillType.Utility
        default:
            return BillType.Loan
    }
}

export const allBillTypes = [
    BillType.CreditCard,
    BillType.Mortgage,
    BillType.StudentLoan,
    BillType.AutoLoan,
    BillType.Utility,
    BillType.Loan,
]

export const merchantBillTypes = (merchant: MerchantDetails) => {
    const types = merchant.types ?? []
    if (!types.length) return null

    const billTypes: BillType[] = []

    for (const type of types) {
        const billType = toBillType(type)
        if (!billTypes.includes(billType)) billTypes.push(billType)
    }

    return billTypes
}
